module.exports = __webpack_public_path__ + "img/CRM_swiperTab_img4.be56a5d7.png";